import { Component } from '@angular/core';

@Component({
  selector: 'app-full-page-loader',
  imports: [],
  templateUrl: './full-page-loader.component.html',
  styleUrl: './full-page-loader.component.scss',
})
export class FullPageLoaderComponent {

}
